// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuItem__container-e65138 {
  --color: var(--base-110);
  --icon-color: var(--base-80);
  --hover-background-color: var(--base-17);
  --focus-visible-background-color: var(--base-17);
  --pushed-background-color: var(--base-20);
  --menu-item-min-height: 40px;
  --menu-item-side-offset: 16px;
  min-height: var(--menu-item-min-height);
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px var(--menu-item-side-offset);
  cursor: pointer;
  color: var(--color);
}

.MenuItem__container-e65138:disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: default;
}

/* dark theme (call panel) */
.MenuItem__dark-theme-bccb8b {
  --color: var(--addition-50);
  --icon-color: var(--addition-50);
  --hover-background-color: var(--addition-50_10);
  --focus-visible-background-color: var(--addition-50_10);
  --pushed-background-color: var(--addition-50_20);
}

.MenuItem__brand-primary-style-a886f5 {
  --color: var(--brand-primary-40);
  --icon-color: var(--brand-primary-40);
}

/* danger style (delete button) */
.MenuItem__danger-style-c95be1 {
  --color: var(--danger-40);
  --icon-color: var(--danger-40);
}

.MenuItem__small-1-size-a64cea,
.MenuItem__small-2-size-faddd0 {
  --menu-item-min-height: 40px;
}

.MenuItem__medium-1-size-d8c08e,
.MenuItem__medium-2-size-f19a3b {
  --menu-item-min-height: 48px;
}

.MenuItem__small-1-size-a64cea,
.MenuItem__medium-1-size-d8c08e {
  --menu-item-side-offset: 16px;
}

.MenuItem__small-2-size-faddd0,
.MenuItem__medium-2-size-f19a3b {
  --menu-item-side-offset: 24px;
}

.MenuItem__container-e65138:hover,
.MenuItem__container-e65138.MenuItem__selected-fc9500,
.MenuItem__container-e65138:hover .MenuItem__dot-container-e16f76,
.MenuItem__container-e65138.MenuItem__selected-fc9500 .MenuItem__dot-container-e16f76 {
  background-color: var(--hover-background-color);
}

@supports (display: block) {
  .MenuItem__container-e65138:focus-visible {
    background-color: var(--focus-visible-background-color);
  }
}
.MenuItem__container-e65138:active,
.MenuItem__container-e65138:active .MenuItem__dot-container-e16f76 {
  background-color: var(--pushed-background-color);
}

.MenuItem__content-d748ac {
  display: flex;
  align-items: center;
  flex: 1 1 100%;
  overflow: hidden;
}

.MenuItem__icon-d2487b,
.MenuItem__icon-suffix-cc21bc {
  width: 24px;
}

.MenuItem__icon-d2487b,
.MenuItem__icon-suffix-cc21bc,
.MenuItem__suffix-c6d027 {
  text-align: center;
  display: flex;
  align-items: center;
  color: var(--icon-color);
}

.MenuItem__icon-suffix-cc21bc,
.MenuItem__suffix-c6d027 {
  flex-shrink: 0;
}

.MenuItem__icon-d2487b {
  margin-inline-end: 24px;
  position: relative;
}

.MenuItem__icon-d2487b svg,
.MenuItem__icon-suffix-cc21bc svg {
  fill: currentColor;
}

.MenuItem__title-ccc9cd {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: currentColor;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.MenuItem__dot-b26153 {
  background: var(--brand-primary-40);
  border-radius: 50%;
  width: 8px;
  height: 8px;
}

.MenuItem__dot-container-e16f76 {
  box-sizing: border-box;
  position: absolute;
  top: -3px;
  inset-inline-end: -3px;
  width: 12px;
  height: 12px;
  padding: 2px;
  background: var(--base-10);
  display: block;
  border-radius: 50%;
}

.MenuItem__value-a3daa4 {
  margin-inline-start: auto;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--brand-primary-40);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/MenuItem/MenuItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,4BAAA;EACA,wCAAA;EACA,gDAAA;EACA,yCAAA;EACA,4BAAA;EACA,6BAAA;EAEA,uCAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;EACA,mBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,YAAA;EACA,eAAA;AAAF;;AAGA,4BAAA;AACA;EACE,2BAAA;EACA,gCAAA;EACA,+CAAA;EACA,uDAAA;EACA,gDAAA;AAAF;;AAGA;EACE,gCAAA;EACA,qCAAA;AAAF;;AAGA,iCAAA;AACA;EACE,yBAAA;EACA,8BAAA;AAAF;;AAGA;;EAEE,4BAAA;AAAF;;AAGA;;EAEE,4BAAA;AAAF;;AAGA;;EAEE,6BAAA;AAAF;;AAGA;;EAEE,6BAAA;AAAF;;AAGA;;;;EAIE,+CAAA;AAAF;;AAGA;EACE;IACE,uDAAA;EAAF;AACF;AAGA;;EAEE,gDAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AADF;;AAIA;;EAEE,WAAA;AADF;;AAIA;;;EAGE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;AADF;;AAIA;;EAEE,cAAA;AADF;;AAIA;EACE,uBAAA;EACA,kBAAA;AADF;;AAIA;;EAEE,kBAAA;AADF;;AAIA;EACE,wBAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,mCAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AADF;;AAIA;EACE,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,0BAAA;EACA,cAAA;EACA,kBAAA;AADF;;AAIA;EACE,yBAAA;EACA,wBAAA;EACA,0CAAA;EACA,8BAAA;AADF","sourcesContent":[".container {\n  --color: var(--base-110);\n  --icon-color: var(--base-80);\n  --hover-background-color: var(--base-17);\n  --focus-visible-background-color: var(--base-17);\n  --pushed-background-color: var(--base-20);\n  --menu-item-min-height: 40px;\n  --menu-item-side-offset: 16px;\n\n  min-height: var(--menu-item-min-height);\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px var(--menu-item-side-offset);\n  cursor: pointer;\n  color: var(--color);\n}\n\n.container:disabled {\n  pointer-events: none;\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* dark theme (call panel) */\n.dark-theme {\n  --color: var(--addition-50);\n  --icon-color: var(--addition-50);\n  --hover-background-color: var(--addition-50_10);\n  --focus-visible-background-color: var(--addition-50_10);\n  --pushed-background-color: var(--addition-50_20);\n}\n\n.brand-primary-style {\n  --color: var(--brand-primary-40);\n  --icon-color: var(--brand-primary-40);\n}\n\n/* danger style (delete button) */\n.danger-style {\n  --color: var(--danger-40);\n  --icon-color: var(--danger-40);\n}\n\n.small-1-size,\n.small-2-size {\n  --menu-item-min-height: 40px;\n}\n\n.medium-1-size,\n.medium-2-size {\n  --menu-item-min-height: 48px;\n}\n\n.small-1-size,\n.medium-1-size {\n  --menu-item-side-offset: 16px;\n}\n\n.small-2-size,\n.medium-2-size {\n  --menu-item-side-offset: 24px;\n}\n\n.container:hover,\n.container.selected,\n.container:hover .dot-container,\n.container.selected .dot-container {\n  background-color: var(--hover-background-color);\n}\n\n@supports (display: block) {\n  .container:focus-visible {\n    background-color: var(--focus-visible-background-color);\n  }\n}\n\n.container:active,\n.container:active .dot-container {\n  background-color: var(--pushed-background-color);\n}\n\n.content {\n  display: flex;\n  align-items: center;\n  flex: 1 1 100%;\n  overflow: hidden;\n}\n\n.icon,\n.icon-suffix {\n  width: 24px;\n}\n\n.icon,\n.icon-suffix,\n.suffix {\n  text-align: center;\n  display: flex;\n  align-items: center;\n  color: var(--icon-color);\n}\n\n.icon-suffix,\n.suffix {\n  flex-shrink: 0;\n}\n\n.icon {\n  margin-inline-end: 24px;\n  position: relative;\n}\n\n.icon svg,\n.icon-suffix svg {\n  fill: currentColor;\n}\n\n.title {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: currentColor;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dot {\n  background: var(--brand-primary-40);\n  border-radius: 50%;\n  width: 8px;\n  height: 8px;\n}\n\n.dot-container {\n  box-sizing: border-box;\n  position: absolute;\n  top: -3px;\n  inset-inline-end: -3px;\n  width: 12px;\n  height: 12px;\n  padding: 2px;\n  background: var(--base-10);\n  display: block;\n  border-radius: 50%;\n}\n\n.value {\n  margin-inline-start: auto;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--brand-primary-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MenuItem__container-e65138`,
	"dark-theme": `MenuItem__dark-theme-bccb8b`,
	"darkTheme": `MenuItem__dark-theme-bccb8b`,
	"brand-primary-style": `MenuItem__brand-primary-style-a886f5`,
	"brandPrimaryStyle": `MenuItem__brand-primary-style-a886f5`,
	"danger-style": `MenuItem__danger-style-c95be1`,
	"dangerStyle": `MenuItem__danger-style-c95be1`,
	"small-1-size": `MenuItem__small-1-size-a64cea`,
	"small1Size": `MenuItem__small-1-size-a64cea`,
	"small-2-size": `MenuItem__small-2-size-faddd0`,
	"small2Size": `MenuItem__small-2-size-faddd0`,
	"medium-1-size": `MenuItem__medium-1-size-d8c08e`,
	"medium1Size": `MenuItem__medium-1-size-d8c08e`,
	"medium-2-size": `MenuItem__medium-2-size-f19a3b`,
	"medium2Size": `MenuItem__medium-2-size-f19a3b`,
	"selected": `MenuItem__selected-fc9500`,
	"dot-container": `MenuItem__dot-container-e16f76`,
	"dotContainer": `MenuItem__dot-container-e16f76`,
	"content": `MenuItem__content-d748ac`,
	"icon": `MenuItem__icon-d2487b`,
	"icon-suffix": `MenuItem__icon-suffix-cc21bc`,
	"iconSuffix": `MenuItem__icon-suffix-cc21bc`,
	"suffix": `MenuItem__suffix-c6d027`,
	"title": `MenuItem__title-ccc9cd`,
	"dot": `MenuItem__dot-b26153`,
	"value": `MenuItem__value-a3daa4`
};
module.exports = ___CSS_LOADER_EXPORT___;
